<template src="../templates/results-count.html" />

<script setup>

import { defineProps, computed, toRefs } from 'vue';
import { regionFilters, categoryFilters, allTaxonomyTerms } from '../config/config';

const props = defineProps({
    results: {
        type: Array,
        required: true,
    },
    totalResults: {
        type: Number,
        required: true,
    },
    searchQuery: {
        type: String,
        required: true,
    },
    selectedCategory: {
        type: String,
        required: true,
    },
    selectedRegion: {
        type: String,
        required: true,
    },
    // eslint-disable-next-line
    selectedTerms: {
        type: Array,
    },
    clearFilters: {
        type: Function,
        required: true,
    },
    layoutType: {
        type: String,
        required: true,
    },
});

const {
    results,
    totalResults,
    searchQuery,
    selectedCategory,
    selectedRegion,
    selectedTerms,
    layoutType,
} = toRefs(props);

const selectedRegionObj = computed(() => {

    return regionFilters.find((region) => {

        return region.region === selectedRegion.value;

    });

});

const selectedCategoryObj = computed(() => {

    return categoryFilters.find((filter) => {

        return filter.category === selectedCategory.value;

    });

});

const selectedTermObjs = computed(() => {

    const termIDs = Object.values(selectedTerms.value);
    return allTaxonomyTerms.filter((term) => {

        return termIDs.includes(term.id);

    });

});

const activeFilters = computed(() => {

    const filters = [];
    if (searchQuery.value) {

        filters.push(searchQuery.value);

    }

    if (selectedCategory.value) {

        filters.push(selectedCategoryObj.value.title);

    }

    if (selectedRegion.value) {

        filters.push(selectedRegionObj.value.title);

    }

    if (selectedTerms.value && Object.values(selectedTerms.value).length) {

        // eslint-disable-next-line
        selectedTermObjs.value.map((term) => {

            filters.push(term.name);

        });

    }
    return filters;

});

const clearSelectedFilters = () => {

    props.clearFilters();

};

</script>
